import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { FlowType } from 'src/app/models/proofreading.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

interface WarnProdFlowDialogOptions {
    title: string;
    text: string;
    relecture: number,
    valid: string;
    options: string[];
}


@Component({
    selector: 'app-warn-prod-flux',
    templateUrl: './warn-prod-flux.component.html',
    styleUrls: ['./warn-prod-flux.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCheckbox, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class WarnProdFlowDialogComponent {
    dialogRef = inject<MatDialogRef<WarnProdFlowDialogComponent>>(MatDialogRef);
    data = inject<WarnProdFlowDialogOptions>(MAT_DIALOG_DATA);

    protected _defaultCtx: WarnProdFlowDialogOptions = {
        title: '',
        text: '',
        relecture: 1,
        options: [],
        valid: 'YES',
    };

    completed: string[] = [];
    incompleted: string[] = [];

    public ctx: WarnProdFlowDialogOptions;

    constructor() {
        this.ctx = _.merge(this._defaultCtx, _.cloneDeep(this.data));
        this.incompleted.push(...this.ctx.options);
    }

    done(todo: string) {
        this.completed.push(todo);
        this.incompleted = this.incompleted.filter(s => s !== todo);
    }

    undone(todo: string) {
        this.incompleted.push(todo);
        this.completed = this.completed.filter(s => s !== todo);
    }

    allDone() {
        return !this.incompleted.length;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
